var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"success",attrs:{"size":"is-small"},on:{"click":_vm.pdfgen}},[_vm._v(" DESCARGAR RESULTADO "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(" mdi-download ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }